export default {"src":"/_next/static/media/Grafana.8474d4a3.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};